export const BASE_URL = 'https://rdc.eshala.co.in';